import { API_URL, setHeader } from 'api';
import axios from 'axios';

const URL = `${API_URL}/app-util/external-api-user`;

export const fetchEAUsers = params => {
  const req = setHeader(axios);
  return req.get(`${URL}`, { params });
};

export const createEAUser = email => {
  const req = setHeader(axios);
  return req.post(`${URL}`, { email });
};

export const reactivateEAUser = id => {
  const req = setHeader(axios);
  return req.put(`${URL}/${id}`, { action: 'REACTIVATE' });
};

export const deactivateEAUser = id => {
  const req = setHeader(axios);
  return req.put(`${URL}/${id}`, { action: 'DEACTIVATE' });
};

export const regenerateEAUserPassword = id => {
  const req = setHeader(axios);
  return req.put(`${URL}/${id}`, { action: 'REGENERATE' });
};
